// NhanXetInput.tsx
import React, { useState } from 'react';
import { Textarea } from '@primer/react';

interface NhanXetInputProps {
  value: string;
  onSave: (value: string) => void;
  disabled?: boolean;
}

const NhanXetInput: React.FC<NhanXetInputProps> = ({ value, onSave, disabled }) => {
  const [localValue, setLocalValue] = useState(value);

  return (
    <Textarea
      value={localValue}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
      onBlur={() => {
        if (localValue !== value) {
          onSave(localValue);
        }
      }}
      rows={1}
      style={{ minWidth: "300px" }}
      disabled={disabled}
    />
  );
};

export default NhanXetInput;